import store from "../../store"

function retonarQuantidade(codigo, sku) {
    let itens = sku ? store.getters.cartProducts.filter((p) => p.codigo == codigo && p.skuSelecionado.sku == sku) : store.getters.cartProducts.filter((p) => p.codigo == codigo)

    let quantidade = 0

    itens.map((item) => {

        quantidade += item.quantidade
    })

    return quantidade
}
export default (codigo, sku) => {
    let quantidade = retonarQuantidade(codigo, sku)

    return quantidade
}